const learnings = {
  status: {
    accepted: "Aprendidos",
    pending: "Sugestões",
    rejected: "Removidos",
  },
  destination: {
    user: "Memória pessoal",
    workspace: "Memória do workspace",
    organization: "Memória da organização",
    mind: "Mind",
  },
  action: {
    memory: {
      create: "Lembrar",
      update: "Atualizar memória",
      delete: "Esquecer memória",
      merge: "Unir memórias",
    },
    mind: {
      create: "Novo bloco",
      update: "Atualizar bloco",
      delete: "Remover bloco",
      merge: "Unir blocos",
    },
  },
  signal: {
    correction: "Correção",
    repeated_question: "Pergunta repetida",
    decision: "Decisão",
    preference: "Preferência",
    unanswered: "Pergunta sem resposta",
    tool_error: "Erro de ferramenta",
    duplicate: "Duplicada",
    contradiction: "Contradição",
    unused: "Sem uso",
    external_agent: "Agente externo",
    inferred: "Notado pelo agente",
  },
  awaiting: {
    you: "Espera você",
    admins: "Espera um administrador",
  },
  why: "Por quê:",
  cause: "Causa provável:",
  fromYou: "Das suas conversas",
  fromConversation: "Sugerida pelo agente durante uma conversa",
  fromAgent: "Enviada por {{client}}",
  externalAgent: "um agente externo",
  referencesButton_one: "{{count}} mensagem",
  referencesButton_other: "{{count}} mensagens",
  accept: "Aplicar",
  editAccept: "Editar e aplicar",
  reject: "Descartar",
  remove: "Remover",
  loadError: "Não foi possível carregar as propostas.",
  empty: {
    workspace:
      "O Prodgy aprende com o uso: ele revisa as conversas deste workspace e guarda aqui o que aprendeu no Brain. Remova o que não estiver certo.",
    personal:
      "O Prodgy aprende com o uso: o que ele aprendeu sobre você, ou das suas conversas, aparece aqui. Remova o que não estiver certo.",
  },
  emptyStatus: {
    pending: "Nenhuma sugestão para a Mind.",
    rejected: "Nada removido.",
  },
  edit: {
    title: "Editar e aplicar",
    description: "Ajuste o texto antes de aplicar na Mind.",
    cancel: "Cancelar",
    confirm: "Aplicar",
  },
  toast: {
    accepted: "Aplicada na Mind.",
    rejected: "Descartada. Ela não será sugerida de novo.",
    removed: "Removido. O Prodgy não vai aprender isso de novo.",
    error: "Não foi possível concluir esta ação.",
  },
  references: {
    title: "De onde veio",
    description: "As mensagens que sustentam esta proposta. Você só vê o texto das suas próprias conversas.",
    hidden: "Mensagem da conversa de outra pessoa",
    empty: "Esta proposta não aponta para mensagens.",
    loadError: "Não foi possível carregar as mensagens.",
  },
  review: {
    now: "Revisar agora",
    done: "Revisão concluída: {{messages}} mensagens lidas, {{proposals}} propostas novas.",
    error: "Não foi possível rodar a revisão.",
  },
  settings: {
    open: "Configurações de Learnings",
    title: "Configurações de Learnings",
    description: "Como o Prodgy revisa as conversas para aprender.",
    enabled: "Revisar as conversas",
    frequency: "Frequência",
    daily: "Diária",
    weekly: "Semanal",
    lastRun: "Última revisão: {{date}}",
    neverRan: "Nenhuma revisão ainda.",
    lastError: "A última revisão falhou: {{error}}",
    saveError: "Não foi possível salvar as configurações.",
  },
  optOut: {
    label: "Não revisar minhas conversas",
    hint: "O Prodgy deixa de ler as suas conversas para propor melhorias no Brain desta organização.",
    saveError: "Não foi possível salvar esta preferência.",
  },
} as const;

export default learnings;
